export const CAIP_NAMESPACE = 'tvm';
export const CAIP_TON_CHAIN_ID = '-239';
